<script setup lang="ts">
    import { Bank } from '@/types';
    import ContinueButton from '@/components/ContinueButton.vue';
    import DialogForm from '@/components/DialogForm.vue';
    import ConnectEconomicForm from '@/components/bank/ConnectEconomicForm.vue';
    import { useForm } from '@inertiajs/vue3';
    import { usePage } from '@inertiajs/vue3';
    import type { SharedData } from '@/types';
    import { computed } from 'vue';
    import QueryKey from '@/enums/QueryKey';

    const props = defineProps<{
        bank: Bank;
    }>();

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const form = useForm({
        account_id: props.bank.id,
        contra_account_id: props.bank.db_account?.contra_account_nr ?? null,
    });

    const successMessage = computed(() => {
        return form.contra_account_id
            ? 'viia.connect_economic_success'
            : 'viia.connect_economic_success_no_contra_account';
    });
</script>

<template>
    <DialogForm
        type="create"
        :form="form"
        :route="route('v2.bank.attach-account')"
        :query-key="[QueryKey.BANK, selectedCompanyId]"
        title="viia.connect_economic"
        :success-message="successMessage"
        error-message="viia.connect_economic_error"
        submit-text="viia.connect_economic"
    >
        <template #trigger>
            <ContinueButton>
                {{ $t('viia.connect_economic') }}
            </ContinueButton>
        </template>
        <ConnectEconomicForm :form="form" />
    </DialogForm>
</template>
